import React, { useState } from 'react';
import './Preguntasfrecuentes.css';

const preguntasPorCategoria = [
  //si quieres agregar preguntas y respuestas hay que seguir la misma logica de corchetes y llaves....
  {
    categoria: '🧭 Sobre Salvir',
    preguntas: [
      {
        pregunta: '¿Qué es Salvir?',
        respuesta:
          'Salvir es un expediente clínico electrónico completo, personalizable por especialidad y certificado NOM-024 por la Secretaría de Salud, con agenda en línea y recordatorios por WhatsApp. Está diseñado para ser fácil de usar: sin curvas de aprendizaje, sin pasos innecesarios y desde cualquier dispositivo. Tus datos y los de tus pacientes están protegidos con cifrado y servidores seguros en AWS. Y lo mejor: todo por $169 al mes. Sin complicaciones. Sin letras chiquitas. Solo lo esencial, al precio justo.',
      },
      {
        pregunta: '¿Quiénes pueden usar Salvir?',
        respuesta:
          'Salvir está pensado para profesionales de la salud que atienden pacientes en consulta. Hoy lo usan médicos generales y especialistas, y estamos sumando a más profesionales como psicólogos, nutriólogos, fisioterapeutas y podólogos.',
      },
      {
        pregunta: '¿Salvir está certificado por la NOM-024?',
        respuesta:
          'Sí. Salvir es un sistema de expediente clínico electrónico (SIRES) certificado por la Dirección General de Información en Salud (DGIS) de la Secretaría de Salud, con el certificado DGIS-CER-P-021-2026-10. Puedes consultarlo en el sitio oficial de la DGIS.',
      },
      {
        pregunta: '¿Cómo empiezo a usar Salvir?',
        respuesta:
          'Para comenzar, solo necesitas registrarte proporcionando algunos datos básicos como tu nombre, especialidad y correo electrónico. También deberás aceptar nuestros Términos y Condiciones y el Aviso de Privacidad. Tu información clínica es tuya: nuestro equipo no sabe quiénes son tus pacientes.',
      },
    ],
  },
  {
    categoria: '📅 Agenda y pacientes',
    preguntas: [
      {
        pregunta: '¿Mis pacientes pueden agendar citas en línea?',
        respuesta:
          'Sí. Tienes tu propia página de citas en línea para que tus pacientes agenden solos, incluso para un familiar. Salvir les envía confirmaciones y recordatorios por WhatsApp, y pueden confirmar desde el mismo mensaje.',
      },
      {
        pregunta: '¿Mis pacientes pueden llenar sus datos antes de la consulta?',
        respuesta:
          'Sí. Con la ficha previa, tu paciente recibe un enlace por WhatsApp y llena sus datos antes de llegar. Así empiezas la consulta con la información lista.',
      },
      {
        pregunta: '¿Puedo agendar a alguien que todavía no es mi paciente?',
        respuesta:
          'Sí. Puedes agendar una cita con solo el nombre y el teléfono, sin abrir expediente. El expediente se crea cuando la persona llega a consulta, con sus datos ya llenos.',
      },
    ],
  },
  {
    categoria: '💻 Compatibilidad y acceso',
    preguntas: [
      {
        pregunta: '¿Salvir funciona en cualquier dispositivo?',
        respuesta:
          'Sí. Puedes acceder desde laptop, tablet o celular usando cualquier navegador actualizado y conexión a internet. No necesitas instalar nada.',
      },
      {
        pregunta: '¿Necesito instalar algo para usar la plataforma?',
        respuesta:
          'No. Salvir funciona 100% en la nube desde tu navegador.',
      },
    ],
  },
  {
    categoria: '💰 Planes y suscripción',
    preguntas: [
      {
        pregunta: '¿Puedo probar Salvir?',
        respuesta:
          'Sí. Al registrarte obtienes 10 días gratis con acceso completo a todas las funcionalidades, sin compromiso y sin necesidad de tarjeta. Es una forma de conocer la plataforma y decidir si se adapta a tu consulta.',
      },
      {
        pregunta: '¿Cuál es el costo del servicio?',
        respuesta:
          'Salvir tiene un único plan con acceso completo a todas las funcionalidades por solo $169 pesos al mes, IVA incluido. También puedes contratar el plan anual por $1,690 y ahorrarte 2 meses. No pagues de más, con Salvir pagas solo lo que necesitas.',
      },
      {
        pregunta: '¿Puedo cancelar mi suscripción en cualquier momento?',
        respuesta:
          'Sí. Puedes cancelar cuando quieras desde tu panel. La cancelación se hace efectiva al final del periodo vigente. Para más detalles consulta nuestros "Términos y Condiciones".',
      },
      {
        pregunta: '¿Puedo llevarme mis expedientes si cancelo?',
        respuesta:
          'Sí. Puedes descargar tus expedientes en PDF en cualquier momento.',
      },
    ],
  },
  {
    categoria: '🔐 Privacidad y seguridad',
    preguntas: [
      {
        pregunta: '¿Salvir puede ver los datos de mis pacientes?',
        respuesta:
          'No sabemos quiénes son tus pacientes. Sus datos personales se guardan cifrados y en nuestras herramientas internas aparecen ocultos. Solo vemos datos generales para que el sistema funcione. Nunca compartimos tu información con terceros.',
      },
      {
        pregunta: '¿Qué tan segura es la plataforma?',
        respuesta:
          'Salvir utiliza cifrado, control de acceso, respaldos diarios automáticos y servidores en la nube de nivel empresarial de Amazon Web Services (AWS). Además, su seguridad fue evaluada y aprobada por la Secretaría de Salud como parte de la certificación NOM-024. Puedes ver más en nuestra sección de Seguridad.',
      },
    ],
  },
  {
    categoria: '🛠️ Soporte y ayuda',
    preguntas: [
      {
        pregunta: '¿Tienen soporte técnico si necesito ayuda?',
        respuesta:
          'Sí. Puedes escribirnos desde la plataforma o contactarnos por WhatsApp o correo. Te ayudamos con gusto.',
      },
    ],
  },
];

// Ficha para Google con todas las preguntas (se genera sola de la lista de arriba)
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: preguntasPorCategoria.flatMap((g) =>
    g.preguntas.map((p) => ({
      "@type": "Question",
      name: p.pregunta,
      acceptedAnswer: { "@type": "Answer", text: p.respuesta },
    }))
  ),
};

const PreguntasFrecuentes = () => {
  const [abierta, setAbierta] = useState(null);

  const togglePregunta = (index) => {
    setAbierta(abierta === index ? null : index);
  };

  let count = 0;

  return (
    <section className="faq-container">
      <h1 className="faq-title">Preguntas Frecuentes</h1>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      {preguntasPorCategoria.map((grupo, i) => (
        <div key={i} className="faq-grupo">
          <h2 className="faq-subtitulo">{grupo.categoria}</h2>
          {grupo.preguntas.map((item, j) => {
            const currentIndex = count++;
            return (
              <div
                key={j}
                className={`faq-item ${abierta === currentIndex ? 'activa' : ''}`}
              >
                <div
                  className="faq-pregunta"
                  onClick={() => togglePregunta(currentIndex)}
                >
                  <span className="faq-icon">{abierta === currentIndex ? '▼' : '▶'}</span>
                  {item.pregunta}
                </div>
                {/* La respuesta siempre está en la página (Google la lee), solo se oculta a la vista */}
                <div
                  className="faq-respuesta"
                  style={{ display: abierta === currentIndex ? undefined : "none" }}
                >
                  {item.respuesta}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </section>
  );
};

export default PreguntasFrecuentes;